import React from "react";
import ModalWrapper from "./ModalWrapper";
import { Stack } from "@mui/material";
import TextView from "../TextView";
import { ASSETS } from "../../utils/config";
import { colors } from "../../utils";

function BroadcastModal({
  isOpen,
  handleClose,
  onSubmit = () => {},
  cancelButtonVisible = true,
  modalText = "Some Description",
  title = "Broadcast Wheel Update!",
  prefixIcon = ASSETS.BroadCastIcon,
  buttonText = "buttonText",
  buttonLoading = false,
}) {
  return (
    <ModalWrapper
      isOpen={isOpen}
      handleClose={handleClose}
      onSubmit={onSubmit}
      isCancelButtonVisible={cancelButtonVisible}
      iconKey="clone"
      title={title}
      prefixIcon={prefixIcon}
      buttonText={buttonText}
      cancelButtonText={!cancelButtonVisible && "Cancel"}
      buttonLoading={buttonLoading}
    >
      <Stack sx={{ mt: 2 }}>
        <TextView color={colors.textGrey} variant="largeText">
          {modalText}
        </TextView>
      </Stack>
    </ModalWrapper>
  );
}

export default BroadcastModal;
